import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import UserAssetsContainer from '../../sources/shared/user-assets/UserAssetsContainer';
import ImageElementAssetImagesLoadMoreCard from './ImageElementAssetImagesLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    assetsContentWrapper: {
        padding: theme.spacing(2)
    }
});

const galleryCardWidth = 145;
const galleryCardHeight = 148;

const ImageElementAssets = ({ imageElementAssets, imageElementAssetsCount, onAssetSelect }) => {
    return (
        <UserAssetsContainer
            userAssets={imageElementAssets}
            onAssetSelect={onAssetSelect}
            loadMoreButton={
                imageElementAssets.length < imageElementAssetsCount ?
                    <ImageElementAssetImagesLoadMoreCard
                        galleryCardHeight={galleryCardHeight}
                        galleryCardWidth={galleryCardWidth}
                    /> : null
            }
        />
    );
};

const mapStateToProps = (state) => {
    const {
        imageElementAssets,
        imageAssets,
        imageElementAssetsCount,
        imageAssetsCount
    } = state.mediaPicker;

    return {
        imageElementAssets: imageElementAssets || imageAssets || [],
        imageElementAssetsCount: imageElementAssetsCount ?? imageAssetsCount ?? 0
    };
};

export default connect(mapStateToProps, {})(withStyles(ImageElementAssets, styles));
